import { CategoryChannelModel } from './CategoryChannelModel'
import { IntegrationSourceEnum, getIntegrationSourceEnumDescription } from '@c2b/muven-commons'

export class CategoryModel {
    id?:string|number = undefined
    idParent?:string|number = undefined
    idSource?:string = undefined
    name:string = ''
    title:string = ''
    description:string = ''
    keywords:string = ''
    createdAt:Date|string|undefined = undefined
    updatedAt:Date|string|undefined = undefined
    isActive:boolean = false
    allowExport:boolean = false
    channels: CategoryChannelModel[] = []
    modificationSource:IntegrationSourceEnum
    parent?: CategoryModel
    loadingListAction: boolean = false

    constructor(c?:Partial<CategoryModel>) {
        Object.assign(this, c)

        this._parseCreatedAt()
        this._parseUpdatedAt()
        this._parseCategoryChannels()
    }

    hasIdSource():boolean {
        return !!this.idSource
    }

    getParentName():string {
        return this.parent?.name || "";
    }

    getIntegrationSourceEnumDescription():string {
        return getIntegrationSourceEnumDescription(this.modificationSource)
    }

    private _parseCreatedAt():void {
        if (typeof this.createdAt === "string") {
            this.createdAt = new Date(this.createdAt)
        }
    }

    private _parseUpdatedAt():void {
        if (typeof this.updatedAt === "string") {
            this.updatedAt = new Date(this.updatedAt)
        }       
    }

    private _parseCategoryChannels():void {
        this.channels = this.channels.map((ch) => {
            return new CategoryChannelModel(ch);
        });
    }
}
